export default "__VITE_ASSET__DR4Iaxwu__"